module.exports = __webpack_public_path__ + "img/proximanova-bold-webfont.2eb3ca93.svg";